export const VISIBILITY_ON = 'visibility_on';
export const VISIBILITY_OFF = 'visibility_off';
export const REPLACE_OPTS = 'replace_opts';
export const DIALOG = 'dialog';
